import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Form, Button, Row, Col } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'
import { DownloadAxiosFile } from 'utils'

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const FormatoCuentaCorriente = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || '',
      cuenta: '',
      moneda: 'SOLES'
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      if (formData.cuenta === '') {
        __zariContext.snack('error', 'Seleccione una cuenta.')
      } else {
        __zariContext.loader.open('Descargando libro Caja-Bancos cuenta corriente...')
        await AsientoContableService.descargarReporteFormato1p2(formData)
          .then(({ data, headers }) => {
            DownloadAxiosFile.downloadAsBlob(data, headers)
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
          .finally(() => {
            __zariContext.loader.close()
          })
      }
    },
    [__zariContext]
  )

  return (
    <>
      {__adminContext.mesTrabajo && (
        <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
          {({ errors, touched, isSubmitting, handleSubmit, values }) => (
            <Form>
              <Row>
                <Col md={8}>
                  <FormGroups.MesContabilidadFormGroup
                    idFormato='reporteCajasBancoEfectivo'
                    iError={errors.mes}
                    iTouched={touched.mes}
                    fIsSubmitting={isSubmitting}
                  />
                  <Row>
                    <Col md={12}>
                      <FormGroups.CuentaFormGroup
                        idFormato='formato1p2'
                        iError={errors.cuenta}
                        iTouched={touched.cuenta}
                        fIsSubmitting={isSubmitting}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <FormGroups.MonedaFormGroup iError={errors.cuenta} iTouched={touched.cuenta} fIsSubmitting={isSubmitting} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button disabled={isSubmitting} onClick={handleSubmit}>
                        {isSubmitting ? 'Descargando reporte ...' : 'Descargar'}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      )}
    </>
  )
}

export default React.memo(FormatoCuentaCorriente)
